<template>
  <div :class="['nv-recharge-store-box', type === 'card' ? 'card-box' : 'page-box']">
    <slot name="prepend"></slot>
    <div class="content">
      <div
        :class="['store-item', activeItem === index ? 'active' : '']"
        @click="selectItem(index)"
        v-for="(item, index) in types"
        :key="index"
      >
        <div v-if="index === 1" class="label-box">
          <NvLabel type="H" />
        </div>
        <img :src="item.icon" :width="item.iconW" :height="item.iconH" />
        <div class="coin-text">{{ item.coin }} Coins</div>
        <div class="bouns">
          <template v-if="item.bonus">
            <span class="val fw500">+{{ item.bonus.value }} </span>
            Bonus
            <span class="per">{{ item.bonus.per }}</span>
          </template>
        </div>
        <div class="money-text">{{ item.dollar }} USD</div>
      </div>
    </div>
    <div class="pay-method-box">
      <div class="title fw500">Payment Method</div>
      <div class="title-tip">
        Enjoy the best value with recommended payment.
      </div>
      <van-radio-group checked-color="#996EFF" class="pay-method-list" v-model="payMethod">
        <van-cell v-for="(item, index) in payList" :key="index" :title="item.label">
          <template #icon>
            <img :src="item.icon" class="pay-icon" />
          </template>
          <template #right-icon>
            <van-radio :name="item.value">{{ item.name }}</van-radio>
          </template>
        </van-cell>
      </van-radio-group>
    </div>

    <slot name="append"></slot>

    <div class="bottom-bar">
      <div class="order-tip">Purchase Order: {{ currentItem.coin }} Coins = {{ currentItem.dollar }} USD</div>
      <NvButton :loading="pending" @click.native="buy" square class="pay-btn fw500" text="PAY NOW" />
    </div>
  </div>
</template>

<script>
import Coin50 from "@/assets/images/coin50.png";
import Coin250 from "@/assets/images/coin250.png";
import Coin800 from "@/assets/images/coin800.png";
import Coin1300 from "@/assets/images/coin1300.png";
import PaypalIcon from "@/assets/images/paypal.png";
import { buyCoins } from "@/service/api";
import {
  setToStorage
  // getFromStorage
} from "@/service/utils";
import NvButton from "@/components/widget/NvButton";
import NvLabel from "@/components/widget/NvLabel";

const cardTypes = [
  {
    type: 1,
    coin: 200,
    dollar: 1,
    icon: Coin50,
    iconH: 40,
    iconW: 50,
    value: "coin_200"
  },
  {
    type: 2,
    coin: 1100,
    dollar: 5,
    icon: Coin250,
    iconH: 40,
    iconW: 63,
    value: "coin_1100",
    bonus: { value: 100, per: "10%" }
  },
  {
    type: 3,
    coin: 2300,
    dollar: 10,
    icon: Coin800,
    iconH: 40,
    iconW: 47,
    value: "coin_2300",
    bonus: { value: 300, per: "15%" }
  }
];

const pageTypes = [
  ...cardTypes,
  {
    type: 4,
    coin: 4800,
    dollar: 20,
    icon: Coin1300,
    iconH: 40,
    iconW: 77,
    value: "coin_4800",
    bonus: { value: 800, per: "20%" }
  }
];

const COIN_KEY = "LAST_PAID_COIN_TYPE";

export default {
  name: "RechargeCard",
  components: { NvButton, NvLabel },
  props: {
    redirect: String,
    type: {
      type: String,
      default: "card" // card holds 3 items while page has 4
    }
  },
  data() {
    return {
      pending: false,
      activeItem: 1,
      payList: [
        {
          icon: PaypalIcon,
          label: "Paypal",
          value: "paypal"
        }
      ],
      payMethod: "paypal"
    };
  },
  computed: {
    types() {
      if (this.type === "card") {
        return cardTypes;
      }
      return pageTypes;
    },
    myCoinsCount() {
      return this.$store.state.user.coins_amount || 0;
    },
    fromPage() {
      return this.$route.name === "recharge-store" ? "Recharge Store" : "Charge Dialog";
    },
    currentItem() {
      return this.types[this.activeItem] || this.types[0];
    },
    currentPayMethod() {
      const list = this.payList;
      const selected = list.filter(i => i.value === this.payMethod);
      return selected[0] || list[0];
    }
  },
  methods: {
    selectItem(index) {
      if (!this.pending) {
        this.activeItem = index;
      }
    },
    buy(flag = true) {
      const coin = this.currentItem;
      if (this.pending) return;
      setToStorage(COIN_KEY, coin);
      // restore button won't trigger this event
      if (flag) {
        window.$event("Click_pay_now_btton", {
          coin: coin.coin,
          from: this.fromPage,
          method: this.payMethod
        });
      }
      this.navigateWithAuth(() => {
        const code = coin.value;
        const redirectUrl = this.redirect || window.location.href;
        this.pending = true;
        buyCoins({ commodity: code, redirect_url: redirectUrl })
          .then(res => {
            this.pending = false;
            window.location.href = res.redirect_url;
          })
          .catch(() => {
            // maybe useless because page is changed in `then` callback
            // here just for ensurance
            this.pending = false;
          });
      });
    }
  },
  mounted() {
    // const lastPaid = getFromStorage(COIN_KEY);
    // if (lastPaid && lastPaid.value) {
    //   const index = pageTypes.map(i => i.value).indexOf(lastPaid.value);
    //   this.activeItem = index < 0 ? 1 : index;
    // } else {
    //   this.activeItem = 1;
    // }
  }
};
</script>

<style lang="scss" scoped>
.nv-recharge-store-box {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  &.page-box {
    .content {
      flex-wrap: wrap;
      justify-content: space-between;
      .store-item {
        width: 44vw;
        margin-top: 8px;
        padding-top: 8px;
      }
      .per {
        display: inline;
      }
    }
  }
  .content {
    display: flex;
    justify-content: center;
    justify-content: space-between;
    width: 100%;
    .store-item {
      position: relative;
      .label-box {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .store-item {
      width: 28vw;
      height: 42vw;
      padding-top: 16px;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      border: 1px solid $color-border;
      &.active {
        border: 1px solid $color-main;
        background: linear-gradient(135deg, white, #ece5ff);
        // box-shadow: 0px 8px 4px 0px rgba(225, 232, 241, 0.5);
        .money-text {
          color: $color-main;
        }
      }
      .coin-text {
        font-weight: 500;
        padding-top: 8px;
        padding-bottom: 16px;
      }
      .bouns {
        font-size: $fs-xs;
        text-align: center;
        height: 25px;
        .val,
        .per {
          color: #ff217b;
        }
        .per {
          border: 1px solid #ff217b;
          padding: 0 8px;
          border-radius: 8px;
          margin-top: 4px;
          display: inline-block;
        }
      }
      .money-text {
        margin-top: 16px;
        color: $fc-grey;
        font-size: $fs-s;
      }
    }
  }
  .pay-method-box {
    margin-top: 32px;
    width: 100%;
    align-self: flex-start;
    .title-tip {
      color: $fc-grey;
      padding: 8px 0;
      font-size: $fs-xs;
      font-weight: 300;
    }
    .pay-method-list {
      width: 100%;
      margin-top: 10px;
      .pay-icon {
        width: 24px;
        height: 24px;
        margin-right: 16px;
      }
      &::v-deep {
        .van-cell {
          padding-left: 0;
          padding-right: 0;
        }
        .van-cell__title {
          font-size: 16px;
        }
      }
    }
  }
  .bottom-bar {
    width: 100%;
    position: fixed;
    text-align: center;
    bottom: 0;
    .order-tip {
      color: $color-main;
      background: #ede6ff;
      padding: 4px 0;
      font-size: $fs-xs;
    }
    .pay-btn {
      background: linear-gradient(135deg, $bg-l-end, $bg-l-start);
      color: white;
      width: 100%;
      height: 45px;
      font-size: $fs-main;
    }
  }
}
</style>
